import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

export default function SEO({
  title,
  description,
  canonical,
  ogType = 'website',
  ogImage = 'https://assets.auxodev.dk/assets/19777474-0f63-4a2a-88a2-aa8209d1f0a9/02690458-fa00-4a74-bd0d-c563c4b7c123.jpg',
  schema,
}) {
  const location = useLocation();
  const siteUrl = window.location.origin;
  const currentUrl = canonical || `${siteUrl}${location.pathname}`;
  const fullTitle = title ? `${title} | Cards by Eve` : 'Cards by Eve | Håndtegnede kort & illustrationer';

  return (
    <Helmet>
      {/* Language */}
      <html lang="da" />

      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={currentUrl} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:site_name" content="Cards by Eve" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {/* Structured Data (Schema Markup) */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
